import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LookupData } from '../models/lookup';
import { map } from 'rxjs/operators';
import { ApiResult } from '../models/ApiResult';


@Injectable({
  providedIn: 'root'
})
export class TestigosService {

  myAppUrl = '';

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTestigos() {
    return this._http.get(this.myAppUrl + 'api/INMTestigos/');
  }

  getTestigo(id:number) {
    return this._http.get(this.myAppUrl + 'api/INMTestigos/' + id);
  }

  getTestigosLookup(searchTerm: string): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/Testigos/Lookup?k=' + searchTerm);
  }

  getTestigosLookupId(id: number): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/Testigos/Lookup/' + id.toString());
  }

  getTestigosFiltered(searchTerm: string) {
    return this._http.get(this.myAppUrl + 'api/INMTestigos?k=' + searchTerm);
  }

  postTestigo(testigo: object): Observable<ApiResult>  {
    return this._http.post<ApiResult>(this.myAppUrl + 'api/INMTestigos/', testigo);
  }

  updateTestigo(testigo: object): Observable<ApiResult> {
    return this._http.put<ApiResult>(this.myAppUrl + 'api/INMTestigos/', testigo);
  }
  deleteTestigo(testigo: number): Observable<ApiResult> {
    return this._http.delete<ApiResult>(this.myAppUrl + 'api/INMTestigos/' + testigo);
  }

  getTipo() {
    return this._http.get(this.myAppUrl + 'api/TipoTestigo');
  }

  getEstado() {
    return this._http.get(this.myAppUrl + 'api/TestigoEstado');
  }

  getEstadoLocalizacion() {
    return this._http.get(this.myAppUrl + 'api/LocalizacionTestigo');
  }
}
